import { render, staticRenderFns } from "./PretragaDokumenata.vue?vue&type=template&id=11f2d5a3&"
import script from "./PretragaDokumenata.vue?vue&type=script&lang=ts&"
export * from "./PretragaDokumenata.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports